"use client"

import { useState, useEffect } from "react"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { ModalMobile } from "./ModalMobile"
import { ModalDesktop } from "./ModalDesktop"

interface ModalProps {
    open?: boolean
    onOpenChange?: (open: boolean) => void
    title: string
    description?: string
    children: React.ReactNode
    mobileHeight?: string
    trigger?: React.ReactNode
    hasDragAndDrop?: boolean
    maxWidth?: string
    desktopContentClassName?: string
    mobileContentClassName?: string
    showBackArrow?: boolean
}

export function Modal({
    open: controlledOpen,
    onOpenChange: controlledOnOpenChange,
    title,
    description,
    children,
    mobileHeight,
    trigger,
    hasDragAndDrop = false,
    maxWidth,
    desktopContentClassName,
    mobileContentClassName,
    showBackArrow
}: ModalProps) {
    const [isMounted, setIsMounted] = useState(false)
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false)
    const isDesktop = useMediaQuery("(min-width: 768px)")

    const isControlled = controlledOpen !== undefined
    const open = isControlled ? controlledOpen : uncontrolledOpen
    const onOpenChange = isControlled ? controlledOnOpenChange! : setUncontrolledOpen

    useEffect(() => {
        setIsMounted(true)
    }, [])

    if (!isMounted) {
        return null
    }

    if (isControlled && !open && !trigger) {
        return null
    }

    return isDesktop ? (
        <ModalDesktop
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            description={description}
            trigger={trigger}
            maxWidth={maxWidth}
            contentClassName={desktopContentClassName}
        >
            {children}
        </ModalDesktop>
    ) : (
        <ModalMobile
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            height={mobileHeight}
            trigger={trigger}
            hasDragAndDrop={hasDragAndDrop}
            contentClassName={mobileContentClassName}
            showBackArrow={showBackArrow}
        >
            {children}
        </ModalMobile>
    )
}